var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "financeApplication__form" },
    [
      _c("ValidationProvider", {
        attrs: {
          name: "residential status",
          rules: _vm.validationRules,
          slim: "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var validate = ref.validate
              return [
                _c(
                  "div",
                  { class: _vm.classNames },
                  _vm._l(_vm.options, function (option) {
                    return _c("FinanceApplicationRadio", {
                      key: option.id,
                      attrs: {
                        name: option.name,
                        "radio-value": option.value,
                        label: option.label,
                        id: option.id,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onInput($event, validate)
                        },
                      },
                      model: {
                        value: _vm.address.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.address, "status", $$v)
                        },
                        expression: "address.status",
                      },
                    })
                  }),
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }